/**
 * Created by Mark on 18/04/2017.
 */


import ENVIRONMENT_CONSTANTS from './environment.js'

export default {
    CREATE_NEW_MEMBER : ENVIRONMENT_CONSTANTS.BASE_URL + '/staffController/createStaffMember',
    GET_ALL_STAFF: ENVIRONMENT_CONSTANTS.BASE_URL + '/staffController/getAccountsStaff',
    GET_DOES_EMAIL_EXISIT: ENVIRONMENT_CONSTANTS.BASE_URL + '/staffController/isEmailAvalible',
    UPDATE_ALL_STAFF: 'UPDATE_ALL_STAFF',
    EDIT_STAFF:ENVIRONMENT_CONSTANTS.BASE_URL   + '/staffController/editStaffMember',
    DELETE_STAFF:ENVIRONMENT_CONSTANTS.BASE_URL + '/staffController/deleteStaff'
}



// WEBPACK FOOTER //
// ./src/constants/staff.js